namespace UIterable {
  export function firstDerived<T, R>(
    iterable: Iterable<T>,
    fn: (item: T) => R
  ) {
    for (const item of iterable) {
      const res = fn(item);
      if (res) return res;
    }
  }
}

export default UIterable;
